export const Logo="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/YouTube_Logo_2017.svg/512px-YouTube_Logo_2017.svg.png"
export const Yt_shorts="https://cdn.pixabay.com/photo/2021/05/22/10/22/youtube-6273167_1280.png"
export const Yt_Music="https://brandlogos.net/wp-content/uploads/2021/11/youtube-music-logo-1-512x512.png"
export const Yt_Kids="https://e7.pngegg.com/pngimages/834/95/png-clipart-youtube-kids-child-mobile-app-youtube-emblem-child-thumbnail.png"

export const YOUTUBE_API_KEY=process.env.REACT_APP_YOUTUBE_API_KEY;

export const FIREBASE_API_KEY=process.env.REACT_APP_FIREBASE_API_KEY;





// export const YOUTUBE_API_KEY_2=process.env.REACT_APP_YOUTUBE_API_KEY_2;




export const YOUTUBE_VIDEO_API="https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=IN&key="+YOUTUBE_API_KEY;

export const YOUTUBE_SINGLE_VIDEO_SEARCH_API="https://youtube.googleapis.com/youtube/v3/videos?part=id%2Csnippet%2Cstatistics%2Cstatus%2Clocalizations&key="+YOUTUBE_API_KEY+"&id=";

export const YOUTUBE_CHANNEL_API="https://youtube.googleapis.com/youtube/v3/channels?part=snippet%2Cid%2Cstatistics%2CcontentOwnerDetails&key="+YOUTUBE_API_KEY+"&id=";

// export const YOUTUBE_SEARCH_API="https://corsproxy.io/?https://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=";
export const YOUTUBE_SEARCH_API = "/api/complete/search?client=firefox&ds=yt&q=";



export const SEARCH_RESULTS="https://www.googleapis.com/youtube/v3/search?key="+YOUTUBE_API_KEY+'&q=';

export const COMMENTS_THREAD='https://www.googleapis.com/youtube/v3/commentThreads?key='+YOUTUBE_API_KEY+'&part=snippet,replies&videoId=';

export const USER_ICON="https://cdn.iconscout.com/icon/premium/png-256-thumb/happy-face-4761755-3956306.png"

export const Live_Chat_Count=50;
